<template>
  <div id="departamentos" :class="{'d-none': !ativo}">
    <template v-for="(departamento, index) in departamentos">
      <ItemLista
        :key="index"
        :height="55"
        :ativo="departamento.expandido"
        class="d-flex align-center"
      >
        <div class="col-6 pa-0 pl-7 d-flex align-center">
<!--          <div class="cursor-pointer" @click="selecionar(departamento)">-->
<!--            <v-icon-->
<!--              v-if="estaSelecionado(departamento)"-->
<!--              color="#142454"-->
<!--              v-text="'mdi-checkbox-marked'"-->
<!--            />-->
<!--            <v-icon v-else color="#142454" v-text="'mdi-checkbox-blank-outline'" />-->
<!--          </div>-->

          <div class="cursor-pointer px-1" @click="expandir(departamento)">
            <v-icon v-if="departamento.expandido" v-text="'mdi-chevron-down'" />
            <v-icon v-else v-text="'mdi-chevron-right'" />
          </div>

          <p
            class="ma-0 coluna-principal pr-3 text-truncate"
            v-text="departamento.nome_departamento"
            :title="departamento.nome_departamento" />
        </div>

        <div class="col-6 pa-0">
          <p class="informacao py-2">
            <span class="descricao">Categorias:&nbsp;</span>
            <span class="valor" v-text="`${departamento.qtd_categorias} · ${departamento.txt_categorias}`" />
          </p>
        </div>
      </ItemLista>

      <v-expand-transition id="categorias-do-departamento" :key="`${index}_`">
        <CategoriasPedidoFornecedor
          :ativo="departamento.expandido"
          :departamento="departamento"
          :selecionarDepartamentoCallback="selecionar"
        />
      </v-expand-transition>
    </template>
  </div>
</template>

<script>
import ItemLista from "./ItemLista";
import CategoriasPedidoFornecedor from "./CategoriasPedidoFornecedor";
import {buscarDepartamentosFornecedorPedido} from "../../../../../../api/compraPorDepartamentos/Fornecedor";

export default {
  name: "DepartamentosDoFornecedor",
  components: {
    ItemLista,
    CategoriasPedidoFornecedor
  },
  props: {
    fornecedor: Object,
    ativo: Boolean,
    selecionarFornecedorCallback: Function,
  },
  data: () => ({
    departamentos: []
  }),
  watch: {
    ativo() {
      if (!this.ativo) return;

      this.buscarDepartamentosFornecedor();
    },
    fornecedor() {}
  },
  methods: {
    buscarDepartamentosFornecedor() {
      if (this.departamentos.length > 0) return;

      const {id_pedido_compra, id_fornecedor} = this.fornecedor;

      this.$store.dispatch('loading/addRequisicao',
        buscarDepartamentosFornecedorPedido(id_pedido_compra, id_fornecedor).then(this.carregarDadosTabela));
    },
    carregarDadosTabela(departamentos) {
      this.departamentos = departamentos.map(this.formatarItemDepartamento);
    },
    formatarItemDepartamento(item, index) {
      item.index = index;
      item.id_fornecedor = this.fornecedor.id_fornecedor;
      item.id_pedido_compra = this.fornecedor.id_pedido_compra;
      item.expandido = false;
      item.produtos = [];
      return item
    },
    selecionar(departamento) {
      let departamentos = [];

      if (this.estaSelecionado(departamento)) {
        departamentos = departamentos.filter(item => item.id_departamento !== departamento.id_departamento);
      } else {
        departamentos.push(departamento);
      }

      this.fornecedor.departamentos = departamentos;

      this.selecionarFornecedorCallback(this.fornecedor);
    },
    expandir(item) {
      item.expandido = !item.expandido;
    },
    estaSelecionado(departamento) {
      if (!this.fornecedor.departamentos || !this.fornecedor.departamentos.length) {
        return true;
      }

      return this.fornecedor.departamentos
        .some(item => item.id_departamento === departamento.id_departamento);
    }
  }
}
</script>

<style scoped>
.departamentos {

}
</style>
